import i18n from "i18next";
import Backend from "i18next-locize-backend";
import { initReactI18next } from "react-i18next";

const locizeOptions = {
  projectId: "16c3ffd7-be59-44c5-9028-a0a658c425db",
  referenceLng: "en"
};

i18n
  // https://github.com/locize/i18next-locize-backend
  .use(Backend)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    lng: "en",
    fallbackLng: "en",
    // keySeparator: false,
    ns: ["ab"],
    defaultNS: "ab",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: locizeOptions,
    react: {
      useSuspense: false
    }
  });

export default i18n;
